module.exports = __webpack_public_path__ + "media/images/icons/prev-white-417e3209c2754d72c1bb6eb97ef1e3e4.svg";